import { setOptions, importLibrary } from "@googlemaps/js-api-loader";

let loaded = false;

// Set by Google if the API key is rejected at runtime (RefererNotAllowedMapError,
// billing/quota, API-not-activated, …). Read it to show a clear message instead of
// leaving the user stuck on a grey "Loading map…" box. Defined once, globally.
if (typeof window !== "undefined" && !window.__gmAuthFailureHooked) {
  window.__gmAuthFailureHooked = true;
  window.gm_authFailure = () => {
    window.__gmAuthFailed = true;
  };
}

export function googleMapsAuthFailed() {
  return typeof window !== "undefined" && window.__gmAuthFailed === true;
}

export async function loadGoogleMaps() {
  if (loaded) return;

  // Configurable so the key can be swapped (or its referrer allow-list changed)
  // without a code edit — falls back to the existing key when the env var is unset.
  const apiKey = process.env.REACT_APP_GMAPS_KEY || "AIzaSyC-lHu38bd4mh86pEK6_c_3M6MlZTSRSTo";
  setOptions({
    key: apiKey,
    v: "weekly",
    libraries: ["places"],
  });

  await importLibrary("maps");
  await importLibrary("places");

  loaded = true;
}
